import React from 'react'
import { EmtButton, EmtButtonProps, EmtIcon } from 'emt-components-v2'
import { useTranslation } from 'next-i18next'

interface Props extends EmtButtonProps {}

const ContactButton: React.FC<Props> = (props) => {
  const { t } = useTranslation('profile')

  return (
    <EmtButton fullWidth color="primary" size="large" startIcon={<EmtIcon className="emt-send" />} {...props}>
      {t('profileSidebar.contact')}
    </EmtButton>
  )
}

export default ContactButton
